<script>
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

export default {
  name: 'ExpiredOverlay',

  setup() {
    const router = useRouter();
    const { accountId } = useAccount();

    /**
     * 跳转到订阅套餐页面（续订）
     */
    const goToBilling = () => {
      console.log('[ExpiredOverlay] goToBilling called', {
        accountId: accountId.value,
        router: !!router,
        routeName: 'subscription_plan'
      });

      router.push({
        name: 'subscription_plan',
        params: { accountId: accountId.value },
      }).then(() => {
        console.log('[ExpiredOverlay] Navigation successful');
      }).catch(error => {
        console.error('[ExpiredOverlay] Navigation failed:', error);
      });
    };

    /**
     * 跳转到订阅使用详情页面
     */
    const goToAccountSettings = () => {
      router.push({
        name: 'subscription_usage',
        params: { accountId: accountId.value },
      });
    };

    return {
      goToBilling,
      goToAccountSettings,
    };
  },
};
</script>

<template>
  <div class="expired-overlay">
    <div class="expired-content">
      <!-- 图标 -->
      <div class="icon">⚠️</div>

      <!-- 标题 -->
      <h2>{{ $t('SUBSCRIPTION_EXPIRED.TITLE') }}</h2>

      <!-- 分割线 -->
      <div class="divider" />

      <!-- 说明文字 -->
      <p class="message">{{ $t('SUBSCRIPTION_EXPIRED.MESSAGE') }}</p>

      <!-- 按钮组 -->
      <div class="button-group">
        <!-- 次要按钮：查看订阅详情 -->
        <button class="secondary-button" @click="goToAccountSettings">
          <span class="icon-text">💳</span>
          {{ $t('SUBSCRIPTION_EXPIRED.VIEW_DETAILS') }}
        </button>

        <!-- 主要按钮：立即续订 -->
        <button class="primary-button" @click="goToBilling">
          <span class="icon-text">✨</span>
          {{ $t('SUBSCRIPTION_EXPIRED.RENEW_BUTTON') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.expired-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(2px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.expired-content {
  position: relative;
  z-index: 1;
  background-color: rgb(var(--solid-1));
  border-radius: 12px;
  padding: 48px 40px;
  max-width: 440px;
  width: 100%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.icon {
  font-size: 72px;
  line-height: 1;
  margin-bottom: 24px;
}

h2 {
  font-size: 24px;
  font-weight: 600;
  color: rgb(var(--slate-12));
  margin: 0 0 16px 0;
}

.divider {
  height: 1px;
  background-color: rgb(var(--slate-6));
  margin: 0 auto 24px auto;
  width: 100%;
}

.message {
  font-size: 14px;
  color: rgb(var(--slate-11));
  margin: 0 0 32px 0;
  line-height: 1.5;
}

.button-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.secondary-button,
.primary-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  width: 100%;
}

.secondary-button {
  background-color: transparent;
  border: 1px solid rgb(var(--slate-7));
  color: rgb(var(--slate-12));

  &:hover {
    background-color: rgb(var(--slate-3));
    border-color: rgb(var(--slate-8));
  }
}

.primary-button {
  background-color: rgb(var(--ruby-9));
  color: rgb(var(--solid-1));

  &:hover {
    background-color: rgb(var(--ruby-10));
  }
}

.icon-text {
  font-size: 16px;
  line-height: 1;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .expired-content {
    padding: 32px 24px;
    max-width: 90%;
  }

  .icon {
    font-size: 48px;
    margin-bottom: 16px;
  }

  h2 {
    font-size: 20px;
  }

  .message {
    font-size: 13px;
  }
}
</style>
